module.exports = __webpack_public_path__ + "img/check-icon.45d49f74.svg";